import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import ActionTypesEnum from '@shared/enums/action-constant.enum';
import { CustomEventService } from '@shared/services/custom-event.service';
import { GlobalSettingsService } from '@shared/services/global-settings.service';

import DateUtil from '@shared/utils/date.util';
import { validateFormGroup } from '@shared/utils/form.util';

import { differenceInCalendarDays } from 'date-fns';

@Component({
  selector: 'app-widget-date-picker-dropdown',
  templateUrl: './widget-date-picker-dropdown.component.html'
})
export class WidgetDatePickerDropdownComponent implements OnChanges, OnInit {

  @Input() widgetId: string;
  @Input() selectedDate;
  @Input() periods: Base.KeyLabelModel[];

  dateUpdateForm: FormGroup;

  dateFormat: string;

  isNextDay = (date: Date) => differenceInCalendarDays(date, new Date()) > 0;
  oneYearAgo = (): Date => {const date = new Date(); date.setFullYear(new Date().getFullYear() - 1); console.log(date);  return date; }
  disabledDate = (current: Date): boolean => this.isNextDay(current) || differenceInCalendarDays(this.oneYearAgo(), current) > 0;

  constructor(
    private customEventService: CustomEventService,
    private fb: FormBuilder,
    private globalSettingsService: GlobalSettingsService
  ) { }

  ngOnInit(): void {
    this.dateFormat = this.globalSettingsService.dateFormat;
    this.createForm();
  }

  createForm(): void {
    this.dateUpdateForm = this.fb.group({
      predefined: [null, Validators.required],
      custom: [null, Validators.required]
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    // detect update of selectedDate and set selected inputs after that
    if (changes.selectedDate) {
      this.setProvidedInputs();
    }
  }

  setProvidedInputs() {
    if (!this.selectedDate) {
      return;
    }

    this.createForm()

    const predefinedFormItem = this.dateUpdateForm.get('predefined');
    const customFormItem = this.dateUpdateForm.get('custom');

    if (isNaN(+this.selectedDate)) {
      predefinedFormItem.patchValue(this.selectedDate);
      customFormItem.clearValidators();
    } else {
      const customDate = new Date(+this.selectedDate);
      customFormItem.patchValue(customDate);
      predefinedFormItem.patchValue('FROM', { emitViewToModelChange: false });
      predefinedFormItem.clearValidators();
    }
  }

  onInputChange(input, event) {
    this.dateUpdateForm.controls[input].setValidators(Validators.required);

    const predefinedFormItem = this.dateUpdateForm.get('predefined');
    const customFormItem = this.dateUpdateForm.get('custom');

    if (typeof event === 'string') {
      if (event === 'FROM') {
        customFormItem.setValidators(Validators.required);
      } else {
        customFormItem.clearValidators();
        customFormItem.patchValue(null, { emitViewToModelChange: false });
      }
    } else {
      predefinedFormItem.clearValidators();
      predefinedFormItem.patchValue('FROM', { emitViewToModelChange: false });
    }
  }

  cancelForm() {
    this.customEventService.announceEvent(ActionTypesEnum.CLOSE_DROPDOWN);
  }

  submitForm() {
    validateFormGroup(this.dateUpdateForm);

    if (this.dateUpdateForm.invalid) {
      return;
    }

    const activeField = Object.entries(this.dateUpdateForm.controls)
      .find(([key, value]) => !!value.validator);

    let inputValue = activeField[1].value;

    if (activeField[0] === 'custom') {
      inputValue = +DateUtil.formatDate(inputValue)
    }

    const data = {
      id: this.widgetId,
      date: inputValue
    };

    this.customEventService.announceEvent(ActionTypesEnum.UPDATE_WIDGET_DATE, data);
    this.customEventService.announceEvent(ActionTypesEnum.CLOSE_DROPDOWN);
  }
}
